
const digest = '90e7c2c3d378a9dd5a5df3f965158793fd61a9c8e2045ea13bc24d41dd828ba6';
const css = `._commandMenuItemIcon_1qab6_1 {
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItemIcon":"_commandMenuItemIcon_1qab6_1"};
export { css, digest };
  